module.exports = __webpack_public_path__ + "img/login-right-image.e6375ee2.svg";